import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import useConsent from "./useConsent";

export default function CookieBanner() {
  const { consent, accept } = useConsent();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!consent) {
      setVisible(true);

      const t = setTimeout(() => {
        accept();
        setVisible(false);
      }, 6000);

      return () => clearTimeout(t);
    }
  }, [consent]);

  if (!visible || consent) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 40, opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="fixed inset-x-0 bottom-4 z-[999] px-4"
      >

        <div className="
          mx-auto w-full max-w-[520px]
          rounded-2xl
          border border-border-soft
          bg-bg-surface/90 backdrop-blur
          shadow-card
          px-4 py-3
        ">

          <div className="flex items-center justify-between gap-3">

            {/* TEXT */}
            <p className="text-[12px] text-text-muted leading-relaxed pr-2">
              We use cookies to improve your experience and analyze usage.
            </p>

            {/* BUTTON */}
            <button
              onClick={() => {
                accept();
                setVisible(false);
              }}
              className="
                shrink-0
                px-3 py-1.5
                rounded-lg
                bg-brand-primary text-white text-[12px] font-medium
                transition-all duration-200
                hover:opacity-90 active:scale-[0.96]
              "
            >
              Got it
            </button>

          </div>

        </div>

      </motion.div>
    </AnimatePresence>
  );
}